import { FontIcons } from '@brandfolder/react';

import { DialogOptions } from '@components/common/providers/DialogContextProvider';

const limitsTypeOptions = {
  admin: {
    icon: 'Person',
    title: bfTranslate('Set Admin limits'),
  },
  collaborator: {
    icon: 'Person',
    title: bfTranslate('Set Collaborator limits'),
  },
  storage: {
    icon: 'Ingest',
    title: bfTranslate('Set storage limits'),
  },
};

export const planLimitsDialogOptions = (
  limitType = 'admin'
): DialogOptions => ({
  id: 'limits-table-dialog',
  dialogClassName: 'set-limits-table-dialog',
  focusLock: false,
  height: 943,
  showFooter: false,
  title: limitsTypeOptions[limitType].title,
  titleIcon: `bff-${FontIcons[limitsTypeOptions[limitType].icon]}`,
  width: 840,
});
